"use client"

import { useState, useEffect, useRef } from "react"
import Header from "../../components/Header/Header"
import Footer from "../../components/Footer/Footer"
import styles from "./CorporatePage.module.css"
import aboutImg from "../../assets/images/Corporate/Corporate-happy-friendship.jpg"
import corporate1 from "../../assets/images/Corporate/corporate1.jpeg"
import corporate2 from "../../assets/images/Corporate/corporate2.jpeg"
import corporate3 from "../../assets/images/Corporate/corporate3.jpeg"
import corporate4 from "../../assets/images/Corporate/corporate4.jpeg"
import corporate5 from "../../assets/images/Corporate/corporate5.jpeg"
import corporate6 from "../../assets/images/Corporate/corporate1 (6).jpeg"
import corporate7 from "../../assets/images/Corporate/corporate1 (7).jpeg"
import corporate8 from "../../assets/images/Corporate/corporate1 (8).jpeg"
import corporate9 from "../../assets/images/Corporate/corporate1 (9).jpeg"
import corporate10 from "../../assets/images/Corporate/corporate1 (10).jpeg"
import corporate11 from "../../assets/images/Corporate/corporate1 (11).jpeg"
import corporate12 from "../../assets/images/Corporate/corporate1 (12).jpeg"
import corporate13 from "../../assets/images/Corporate/corporate1 (13).jpeg"
import patients1 from "../../assets/images/Corporate/happy-hair.jpg"
import patients2 from "../../assets/images/Corporate/happy-Rhinoplasty.jpg"

export default function CorporatePage() {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [isTransitioning, setIsTransitioning] = useState(false)
  const [isDragging, setIsDragging] = useState(false)
  const [dragX, setDragX] = useState(0)
  const [offsetX, setOffsetX] = useState(0)
  const dragStartXRef = useRef(0)
  const trackRef = useRef(null)
  const containerRef = useRef(null)
  const [tileWidth, setTileWidth] = useState(0)
  const GAP = 0
  
  // Corporate images for slider (excluding about.png)
  const sliderImages = [
    { src: corporate1, alt: "Corporate Facility 1" },
    { src: corporate2, alt: "Corporate Facility 2" },
    { src: corporate3, alt: "Corporate Facility 3" },
    { src: corporate4, alt: "Corporate Facility 4" },
    { src: corporate5, alt: "Corporate Facility 5" },
    { src: corporate6, alt: "Corporate Facility 6" },
    { src: corporate7, alt: "Corporate Facility 7" },
    { src: corporate8, alt: "Corporate Facility 8" },
    { src: corporate9, alt: "Corporate Facility 9" },
    { src: corporate10, alt: "Corporate Facility 10" },
    { src: corporate11, alt: "Corporate Facility 11" },
    { src: corporate12, alt: "Corporate Facility 12" },
    { src: corporate13, alt: "Corporate Facility 13" }
  ]

  // Calculate tile width based on container
  useEffect(() => {
    const calc = () => {
      const el = containerRef.current
      if (!el) return
      const w = el.getBoundingClientRect().width
      setTileWidth(w)
    }
    calc()
    window.addEventListener("resize", calc)
    return () => window.removeEventListener("resize", calc)
  }, [])

  const nextSlide = () => {
    if (isTransitioning) return
    const track = trackRef.current
    if (!track) return
    const delta = -tileWidth
    setIsTransitioning(true)
    track.style.transition = "transform 300ms ease"
    setOffsetX(delta)
    const onEnd = () => {
      track.style.transition = "none"
      setCurrentSlide((prev) => (prev + 1) % sliderImages.length)
      setOffsetX(0)
      setIsTransitioning(false)
      track.removeEventListener("transitionend", onEnd)
    }
    track.addEventListener("transitionend", onEnd)
  }

  const prevSlide = () => {
    if (isTransitioning) return
    const track = trackRef.current
    if (!track) return
    const delta = tileWidth
    setIsTransitioning(true)
    track.style.transition = "transform 300ms ease"
    setOffsetX(delta)
    const onEnd = () => {
      track.style.transition = "none"
      setCurrentSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length)
      setOffsetX(0)
      setIsTransitioning(false)
      track.removeEventListener("transitionend", onEnd)
    }
    track.addEventListener("transitionend", onEnd)
  }

  const goToSlide = (index) => {
    if (isTransitioning || index === currentSlide) return
    setCurrentSlide(index)
  }

  // Get window slides for smooth transitions
  const getWindowSlides = () => {
    const len = sliderImages.length
    const prevIdx = (currentSlide - 1 + len) % len
    const arr = [sliderImages[prevIdx]]
    arr.push(sliderImages[currentSlide])
    const nextIdx = (currentSlide + 1) % len
    arr.push(sliderImages[nextIdx])
    return arr
  }

  const baseOffset = -tileWidth // hide the leading prev tile

  // Drag handlers (pointer events)
  const onPointerDown = (e) => {
    if (isTransitioning) return
    setIsDragging(true)
    setDragX(0)
    dragStartXRef.current = e.clientX ?? (e.touches && e.touches[0] && e.touches[0].clientX) ?? 0
  }

  useEffect(() => {
    if (!isDragging) return
    const onMove = (e) => {
      const clientX = e.clientX ?? (e.touches && e.touches[0] && e.touches[0].clientX)
      if (clientX == null) return
      setDragX(clientX - dragStartXRef.current)
    }
    const onUp = () => {
      const threshold = 50
      const track = trackRef.current
      if (!track) return
      
      if (dragX <= -threshold) {
        // go next - slide left
        setIsTransitioning(true)
        track.style.transition = "transform 300ms ease"
        setOffsetX(-tileWidth)
        const onEnd = () => {
          track.style.transition = "none"
          setCurrentSlide((prev) => (prev + 1) % sliderImages.length)
          setOffsetX(0)
          setIsTransitioning(false)
          track.removeEventListener("transitionend", onEnd)
        }
        track.addEventListener("transitionend", onEnd)
      } else if (dragX >= threshold) {
        // go prev - slide right
        setIsTransitioning(true)
        track.style.transition = "transform 300ms ease"
        setOffsetX(tileWidth)
        const onEnd = () => {
          track.style.transition = "none"
          setCurrentSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length)
          setOffsetX(0)
          setIsTransitioning(false)
          track.removeEventListener("transitionend", onEnd)
        }
        track.addEventListener("transitionend", onEnd)
      } else {
        // snap back to center
        setIsTransitioning(true)
        track.style.transition = "transform 300ms ease"
        setOffsetX(0)
        const onEnd = () => {
          track.style.transition = "none"
          setIsTransitioning(false)
          track.removeEventListener("transitionend", onEnd)
        }
        track.addEventListener("transitionend", onEnd)
      }

      setIsDragging(false)
      setDragX(0)
    }
    window.addEventListener("pointermove", onMove)
    window.addEventListener("pointerup", onUp)
    window.addEventListener("touchmove", onMove, { passive: true })
    window.addEventListener("touchend", onUp)
    return () => {
      window.removeEventListener("pointermove", onMove)
      window.removeEventListener("pointerup", onUp)
      window.removeEventListener("touchmove", onMove)
      window.removeEventListener("touchend", onUp)
    }
  }, [isDragging, dragX, tileWidth, sliderImages.length])

  return (
    <>
      <Header />
      <main className={styles.main}>
        <div className={styles.container}>
          {/* Header Section */}
          <section className={styles.headerSection}>
            <h1 className={styles.title}>
              <span className={styles.highlight}>Guided by Excellence,</span>  Driven by Results.
            </h1>
          </section>

          

          {/* Image Section */}
          <section className={styles.imageSection}>
            <div className={styles.imageContainer}>
              <img 
                src={aboutImg} 
                alt="About Us"
                className={styles.mainImage}
              />
            </div>
          </section>

          {/* Footer Text Section */}
          <section className={styles.textSection}>
            <p className={styles.paragraph}>
              This commitment comes to life through an unwavering dedication to patient experience, world-class medical partnerships, and the integration of cutting-edge technology.
            </p>
            <p className={styles.paragraphBold}>
              We are committed to making exceptional healthcare accessible, breaking down financial barriers to ensure everyone receives the care they deserve.
            </p>
          </section>

          {/* Statistics Section */}
          <section className={styles.statsSection}>
            <div className={styles.statsContainer}>
              {/* Left Side - Image Slider */}
              <div className={styles.sliderCard}>
                <h2 className={styles.sliderTitle}>Places Where We Host Our Patients</h2>
                <div className={styles.sliderContainer}>
                  <button className={styles.sliderBtn} onClick={prevSlide} aria-label="Previous image">
                    ‹
                  </button>
                  <div 
                    ref={containerRef}
                    className={styles.sliderImageContainer}
                    onPointerDown={onPointerDown}
                    style={{ cursor: isDragging ? "grabbing" : "grab" }}
                  >
                    <div
                      ref={trackRef}
                      className={styles.sliderTrack}
                      style={{
                        transform: `translateX(${baseOffset + offsetX + dragX}px)`,
                      }}
                    >
                      {getWindowSlides().map((slide, i) => (
                        <div
                          className={styles.sliderTile}
                          key={`${currentSlide}-${i}`}
                          style={{
                            width: '100%',
                          }}
                        >
                          <img 
                            src={slide.src} 
                            alt={slide.alt}
                            className={styles.sliderImage}
                            draggable={false}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                  <button className={styles.sliderBtn} onClick={nextSlide} aria-label="Next image">
                    ›
                  </button>
                </div>
                <div className={styles.sliderDots}>
                  {sliderImages.map((_, index) => (
                    <button
                      key={index}
                      className={`${styles.dot} ${currentSlide === index ? styles.activeDot : ''}`}
                      onClick={() => goToSlide(index)}
                      aria-label={`Go to slide ${index + 1}`}
                    />
                  ))}
                </div>
              </div>

              {/* Right Side - Statistics */}
              <div className={styles.statsCard}>
                <div className={styles.statsGrid}>
                  <div className={styles.statItem}>
                    <div className={styles.statNumber}>12</div>
                    <div className={styles.statLabel}>Years Expertise</div>
                  </div>
                  <div className={styles.statItem}>
                    <div className={styles.statNumber}>%95</div>
                    <div className={styles.statLabel}>Patient Satisfaction</div>
                  </div>
                  <div className={styles.statItem}>
                    <div className={styles.statNumber}>15+</div>
                    <div className={styles.statLabel}>Specialist Advisors</div>
                  </div>
                  <div className={styles.statItem}>
                    <div className={styles.statNumber}>8+</div>
                    <div className={styles.statLabel}>Spoken Language</div>
                  </div>
                </div>
                <p className={styles.statsDescription}>
                  We blend international quality standards with personalized care to deliver a treatment experience that is both exceptional and reassuring.
                </p>
              </div>
            </div>
          </section>
        </div>
        
  {/* Privileges / Patients Section - moved to page bottom */}
  <div className={styles.container}>
          <section className={styles.privilegesSection}>
            <div className={styles.privilegesContainer}>
              <div className={styles.patientsColumn}>
                <div className={styles.patientTop}>
                  <img src={patients1} alt="Patient 1" className={styles.patientImg} />
                </div>
                <div className={styles.patientMiddle}>
                  <p className={styles.patientText}>
                    As a trusted global health partner, we break down barriers to bring exceptional care within your reach.
                  </p>
                </div>
                <div className={styles.patientBottom}>
                  <img src={patients2} alt="Patient 2" className={styles.patientImg} />
                </div>
              </div>

              <div className={styles.privilegesColumn}>
                <div className={styles.privilegesHeaderBox}>
                  <p className={styles.privilegesTopText}>
                    We've created a healing environment where your comfort is our priority, so you can focus entirely on your recovery, feeling safe and fully supported.
                  </p>
                </div>

                <h2 className={styles.privilegesTitle}>The EstaVerde 
                  <span className={styles.privilegesTitleAccent}> Advantage</span>
                </h2>

                <ul className={styles.privilegesList}>
                  <li className={styles.privilegeItem}><span className={styles.iconPlaceholder}>📞</span> Always-On Patient Support</li>
                  <li className={styles.privilegeItem}><span className={styles.iconPlaceholder}>🧪</span> Groundbreaking Medical Technology</li>
                  <li className={styles.privilegeItem}><span className={styles.iconPlaceholder}>⭐</span> Unwavering Comfort</li>
                  <li className={styles.privilegeItem}><span className={styles.iconPlaceholder}>👩‍⚕️</span> World-Class Specialist Team</li>
                </ul>
              </div>
            </div>
          </section>
        </div>
        
        {/* Footer */}
        <Footer />
      </main>
    </>
  )
}
